<div class="min-h-screen bg-base-100 flex flex-col items-center py-[7rem] px-6">
	
	<div class="text-center mb-10">
		<h1 class="font-extrabold text-base-content mb-2">
			Bienvenu sur Ziggy
		</h1>
		<p class="text-base-content">
			Saisissez les identifiants du magasin
		</p>
	</div>

	<form [formRoot]="loginForm" class="w-full max-w-sm flex flex-col gap-4">
		
		<label class="form-control form-control text-center">
			<input 
				type="email" 
				placeholder="Email"
				[formField]="loginForm.email"
				class="input input-bordered rounded-full focus:input-primary w-[200px]" 
			/>
			@let emailControl = loginForm.email();
			@if (emailControl.invalid() && emailControl.touched()) {
				<p class="text-error text-sm">
					@for (error of emailControl.errors(); track error.kind) {
						{{ error.message }}
					}
				</p>
			}
		</label>

		<label class="form-control text-center">
			<input 
				type="password" 
				placeholder="Mot de passe" 
				[formField]="loginForm.password"
				class="input input-bordered rounded-full focus:input-primary w-[200px]" 
			/>
			@let passwordControl = loginForm.password();
			@if (passwordControl.invalid() && passwordControl.touched()) {
				<p class="text-error text-sm">
					@for (error of passwordControl.errors(); track error.kind) {
						{{ error.message }}
					}
				</p>
			}
		</label>

		<div class="mt-8 flex justify-center">
			@let is_loading = loading();
			<button class="btn btn-primary rounded-lg text-white normal-case" type="submit" [disabled]="is_loading">
				@if (is_loading) {
					<span class="loading loading-spinner"></span>
				}
				Se connecter
			</button>
		</div>

	</form>

	<div class="h-20"></div>
</div>